import React from 'react';
const helpers={


    itemStatusDesc: function(itemStatus){
        var status = '';
        switch(itemStatus){
          case 'A' : status =  'Archived'; break;
          case 'C' : status =  'Claimed'; break;
          case 'P' : status =  'Published'; break;
          case 'Q' : status =  'Unclaimed'; break;
          case 'R' : status =  'Returned'; break;
          case 'D' : status =  'Donated'; break;
          case 'T' : status =  'Disposed'; break;
          default: status = '';
      
        }

        return status;
      },
   
       statusColFormater: function(fieldValue, row, rowIdx, colIdx) {
        // fieldValue is column value
        // row is whole row object
        // rowIdx is index of row
        // colIdx is index of column
        //console.log(fieldValue);
      
        if (fieldValue==='Q'){
          return "alert-info";
        }else if (fieldValue==='C' || fieldValue==='R'){
          return "alert-success";
        }else if (fieldValue==='A'){
          return "";
        }else{
          return "";
        }
        //return ({'background-color':'red'});
      
      },

      formatDateTime: function(cell,row){
        try {
            if (cell){
                var options = { year: 'numeric', month: 'numeric', day: 'numeric' };
                let cellDate = new Date(cell);
                return cellDate.toLocaleDateString([],options) +  ' ' + cellDate.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'});
            }else{
                return  '';
            }
        }catch(e){
            return  '';

        }
      },

      formatDate: function(cell,row){
        try {
            if (cell){
                var options = { year: 'numeric', month: 'numeric', day: 'numeric' };
                return new Date(cell).toLocaleDateString([],options);
            }else{
                return  '';
            }
        }catch(e){
            return  '';

        }
        
        
    },
    formatTime: function(cell,row){
        try {
            if (cell){
                //var options = { year: 'numeric', month: 'long', day: 'numeric' };
                return new Date(cell).toLocaleTimeString([]);
            }else{
                return  '';
            }
        }catch(e){
            return  '';

        }
        
        
    },

    formatDateLongDate: function(dateVal){
        try {
            if (dateVal){
                var options = {weekday:'long', year: 'numeric', month: 'long', day: 'numeric' };
                return dateVal.toLocaleDateString([],options);
            }else{
                return  'MISSING';
            }
        }catch(e){
            return  'ERR:' + e;

        }
        
        
    },
    formatKeyword: function (cell,row){
        // if there are keywords, only show the first 50 characters.
        if (row.keywords){
          
          let formattedAddSpaces = row.keywords.replaceAll(',', ', ');  //need to add spaves for line wraping
          let strVal =  (formattedAddSpaces.length > 200) ? formattedAddSpaces.substr(0, 200-1) + '...' : formattedAddSpaces;
          return( <span style={{fontSize:'12px'}}>{strVal}</span> );
        }else{
          return( <small ></small> );
        }
        
      },
      formatKeywordAll: function (cell,row){
        // if there are keywords, only show the first 50 characters.
        if (row.keywords){
          
          let formattedAddSpaces = row.keywords.replaceAll(',', ', ');  //need to add spaves for line wraping
         
          return( <small>{formattedAddSpaces}</small> );
        }else{
          return( <small ></small> );
        }
        
      },
      
      formatShortAndLong: function (cell, row){
        if (cell){
          return (
            <div>
            <div className='row'>
              <div className='col text-left text-info'><p className='text-info' style={{fontSize:'16px'}}><b>{row.shortDescription} </b></p>  </div>
              </div>
              <div className='row'> 
              <div className='col text-left' style={{fontSize:'12px'}}> {row.longDescription}  </div>
            </div>
            
            </div>
          )
        }
      },
      formatShortAndLongWithBarcode: function (cell, row){
        if (cell){
          return (
            <div>
            <div className='row'>
              <div className='col text-left text-info'><p className='text-info' style={{fontSize:'16px', fontWeight:'bold'}}>{row.shortDescription}</p>  </div>
              </div>
              <div className='row'> 
                <div className='col text-left' style={{fontSize:'12px'}}> {row.longDescription}  </div>
             </div>
             <div className='row'> 
                <div className='col text-left' style={{fontSize:'10px'}}> {(row.barCodeValue)? 'Bag/Barcode:' + row.barCodeValue : ''}  </div>
             </div>
             <div className='row'> 
                <div className='col text-left' style={{fontSize:'10px'}}> {(row.ownerName)? 'Owner/Guest:' + row.ownerName : ''}  </div>
             </div>
            </div>
          )
        }
      },
      formatAirlineDetails:function(cell,row){
        if (row){
          return (
            <div>
            <div className='row'> 
                  
                 
                  <div className='col text-left text-info'><span className='text-primary' style={{fontSize:'12px'}}></span> <span className='text-info' style={{fontSize:'13px'}}><b>{row.locationName} </b></span>  </div>

             </div>
            <div className='row'>
                 
                  <div className='col text-left text-info'><span className='text-primary' style={{fontSize:'12px'}}>Flight:</span> <span className='text-info' style={{fontSize:'12px'}}><b>{row.flightNumber} </b></span>  </div>
                  <div className='col text-left text-info'><span className='text-primary' style={{fontSize:'12px'}}>Seat/Row:</span> <span className='text-info' style={{fontSize:'12px'}}><b>{row.seat} </b></span>  </div>
              </div>
              <div className='row'> 
                 
                <div className='col text-left text-info'><span className='text-primary' style={{fontSize:'12px'}}>Terminal:</span> <span className='text-info' style={{fontSize:'12px'}}><b>{row.terminal} </b></span>  </div>
                
             </div>

             <div className='row'> 
                 
                 <div className='col text-left text-info'><span className='text-primary' style={{fontSize:'12px'}}>Gate/Lounge:</span> <span className='text-info' style={{fontSize:'12px'}}><b>{row.gate} </b></span>  </div>
                 
              </div>
           
          
            </div>
          )
        }else{
          return (
            <p className='text-primary text-center' style={{fontSize:'12px'}}>NA</p>
          )
        }
      },
      formatAirlineDetailsFlat:function(cell,row){
        if (row){
          return (
            <div>
            <div className='row'>
                 
                  <div className='col text-left text-info'><span className='text-primary' style={{fontSize:'12px'}}>Flight:</span> <span className='text-info' style={{fontSize:'12px'}}><b>{row.flightNumber} </b></span>  </div>
                  <div className='col text-left text-info'><span className='text-primary' style={{fontSize:'12px'}}>Seat/Row:</span> <span className='text-info' style={{fontSize:'12px'}}><b>{row.seat} </b></span>  </div>
                  <div className='col text-left text-info'><span className='text-primary' style={{fontSize:'12px'}}>Terminal:</span> <span className='text-info' style={{fontSize:'12px'}}><b>{row.terminal} </b></span>  </div>
                 <div className='col text-left text-info'><span className='text-primary' style={{fontSize:'12px'}}>Gate/Lounge:</span> <span className='text-info' style={{fontSize:'12px'}}><b>{row.gate} </b></span>  </div>
                <div className='col text-left text-info'><p className='text-primary' style={{fontSize:'12px'}}>Details:<b>{row.locationName} </b></p>  </div>

             </div>
            </div>
          )
        }else{
          return (
            <p className='text-primary text-center' style={{fontSize:'12px'}}>NA</p>
          )
        }
      },
      formatAge:function(cell,row){
        
        try{
          if (cell){
            var today = new Date();
            var foundDate = (cell) ?   Date.parse(cell): Date () ;
            var res = Math.abs(today - foundDate) / 1000;
            var days = Math.floor(res / 86400);
            return days;
          }
        }catch(e){
          return -1;
        }
       
      },
      formatMoney: function(number){
        try{
          return number.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
        }catch(e){
          return '';
        }
      
    },
    formatBoolean:function(value){
      try {
        return (
          (value) ? 'YES' : 'NO'
        )
      } catch (e) {
        return '';
      }
    }

}

export default helpers;